<template>
    <div ref="modal" :id="uniqueId" :class="{modal: isModalForm}">
        <div :class="{modal_container: isModalForm}">
            <div :class="{modal_content: isModalForm}">
                <button v-if="isModalForm" class="modal_close" data-dismiss="modal" @click="clear" type="button"></button>

                <template v-if="isSended && !this.errorMessages.length">
                    <div class="modal_title">Ваш запрос отправлен</div>

                    <div :class="formClass">
                        <p>Мы свяжемся с вами в ближайшее время</p>

                        <div class="modal_result_buttons">
                            <a v-if="!isModalForm" href="#" @click.prevent="clear" class="btn btn-accent">Вернуться</a>
                            <a v-if="isModalForm" href="#" @click="clear" data-dismiss="modal" class="btn btn-accent">Закрыть</a>
                        </div>
                    </div>
                </template>

                <template v-if="isSended && this.errorMessages.length">
                    <div class="modal_title">Ваш запрос не отправлен</div>

                    <div :class="formClass">
                        <p>Произошла ошибка при отправке. Приносим свои извинения, при отправлении данных произошла какая-то ошибка. Заполните, пожалуйста, форму ещё раз.</p>
                        <div class="modal_result_buttons">
                            <a href="#" @click.prevent="clear" class="btn btn-accent">Вернуться</a>
                            <a v-if="isModalForm" href="#" @click="clear" data-dismiss="modal" class="link-blue">Закрыть</a>
                        </div>
                    </div>
                </template>

                <template v-if="!isSended">
                    <div class="modal_title">{{ formTitle }}</div>
                    <p v-if="formSubTitle" class="modal_subtitle">{{ formSubTitle }}</p>

                    <div :class="formClass">
                        <form action="#">
                            <div v-if="errorMessages.length" class="form-msg error">{{ errorMessages[0] }}</div>

                            <fieldset class="form-fieldset">
                                <div v-for="(field, name) in fields" class="form-group">
                                    <input
                                        :ref="'input_' + name"
                                        class="input-text"
                                        type="text"
                                        v-if="field.type === 'text' || field.type === 'email' || field.type === 'phone'"
                                        v-model="values[name]"
                                        :class="{error: errorFields.indexOf(name) !== -1}"
                                        :placeholder="field.placeholder"
                                        :disabled="isLoading"
                                    >

                                    <template v-if="field.type === 'radio'">
                                        <div v-if="field.placeholder" class="form-fieldset_title">{{ field.placeholder }}</div>

                                        <div class="form-group form-group--input-radio-card">

                                            <div v-for="(item, index) in field.values" class="input-radio-card">
                                                <input type="radio" :disabled="isLoading" v-model="values[name]" :value="item" :name="uniqueId + name" :id="name + uniqueId + index">
                                                <label class="period" :for="name + uniqueId + index">
                                                    <span class="period_name">
                                                        {{ item.unit }}
                                                        <span class="period_sale" v-if="item.old_price !== 0">{{ Math.round((parseInt(item.old_price)-parseInt(item.value))/parseInt(item.old_price)*100)}}%</span>
                                                    </span>

                                                    <span class="period_month">{{Math.round(parseInt(item.value) / parseInt(item.duration)) | price('')}} <small>р/мес</small></span>
                                                    <span class="period_old" v-if="item.old_price !== 0">{{ item.old_price | price('') }}</span>
                                                    <span class="period_cost">{{ item.value | price('') }}</span>
                                                </label>
                                            </div>

                                        </div>
                                    </template>
                                </div>

                                <!-- <div>
                                    <vue-recaptcha ref="recaptcha" @verify="onRecaptchaVerify" @expired="onRecaptchaExpired" :sitekey="recaptchaSiteKey"></vue-recaptcha>
                                </div> -->

                            </fieldset>
                            <div v-if="formPrice" class="form-price">
                                {{ formPrice | price }}
                            </div>
                            <div class="form-footer">
                                <button :disabled="isLoading" class="btn btn-accent" @click.prevent="submit" type="submit">
                                    {{ submitTitle }}
                                </button>
                                <div>Нажимая на кнопку, вы даете согласие на&nbsp;обработку<a class="link-blue" href="/confidence"> персональных данных</a></div>
                            </div>
                        </form>
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
    import map from "lodash/map";
    import filter from "lodash/filter";
    import Inputmask from "inputmask";
    import {baseFormMixin, fieldsMixin} from "../mixins";
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        mixins: [baseFormMixin, fieldsMixin],
        components: { VueRecaptcha },

        computed: {
            errorFields() {
                return filter(map(this.fields, (field, name) => {
                    const value = this.values[name];
                    if (!!value && typeof field.validation === 'function' && !field.validation(value)) {
                        return name;
                    }
                }));
            },
            recaptchaSiteKey() {
                return window.Laravel.recaptchaSiteKey
            }
        },

        data() {
            return {
                isSended: false,
                isLoading: false,
                isRecaptchaPasssed: false,
                errorMessages: [],
                values: {

                },
            }
        },

        mounted() {
            map(this.fields, (field, name) => {
                if (field.type === 'phone') {
                    Inputmask({"mask": "+7 (999) 999-9999"}).mask(this.$refs['input_' + name]);
                }
            });
        },

        created() {
            map(this.fields, (field, name) => {
                if (field.value) {
                    this.values[name] = field.value;
                } else if ( (field.type === 'radio' || field.type === 'checkbox') && field.required ) {
                    // console.log(field);
                    let selectedValue = null;
                    for (let i in field.values) {
                        const v = field.values[i];
                        if (v.default) {
                            selectedValue = v;
                        }
                    }

                    if (!selectedValue) {
                        selectedValue = field.values[0];
                    }
                    this.values[name] = selectedValue;
                }
            });
        },

        methods: {

            clear() {
                this.isLoading = false;
                this.isSended = false;
                this.errorMessages = [];
                this.values = {};
                this.isRecaptchaPasssed = false;

                if (this.$refs.recaptcha) {
                    this.$refs.recaptcha.reset();
                }

                map(this.fields, (field, name) => {
                    if (field.value) {
                        this.values[name] = field.value;
                    } else if ( (field.type === 'radio' || field.type === 'checkbox') && field.required ) {
                        this.values[name] = field.values[0];
                    }
                });
            },

            onRecaptchaVerify() {
                this.isRecaptchaPasssed = true;
            },

            onRecaptchaExpired() {
                this.isRecaptchaPasssed = false;
            },

            validate() {
                this.errorMessages = [];

                map(this.fields, (field, name) => {
                    const value = this.values[name];

                    if (field.required && !value) {
                        this.errorMessages.push(field.messages.empty);
                    } else if (typeof field.validation === 'function' && !field.validation(value)) {
                        this.errorMessages.push(field.messages.invalid);
                    }
                });

                // if (!this.isRecaptchaPasssed) {
                //    this.errorMessages.push('Пожалуйста, подтвердите, что вы не робот');
                // }

                return !this.errorMessages.length;
            },

            submit() {
                if (!this.validate()) {
                    return false;
                }

                this.isLoading = true;

                this.onSubmit(this.values)
                .then((response) => {
                    this.isSended = true;
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.isSended = true;
                    this.errorMessages = ['Произошла ошибка при отправке. Приносим свои извинения, при отправлении данных произошла какая-то ошибка. Заполните, пожалуйста, форму ещё раз.'];
                    this.isLoading = false;
                });

            }
        },
    }
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/BaseForm.vue